"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsightDraggingComponent = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var DraggableInsightList_1 = require("../../dashboard/DashboardSidebar/DraggableInsightList");
/*
 * @internal
 */
function InsightDraggingComponent(_a) {
    var item = _a.item;
    var insight = item.insight;
    var visualizationUrl = sdk_model_1.insightVisualizationUrl(insight);
    var visualizationType = visualizationUrl === null || visualizationUrl === void 0 ? void 0 : visualizationUrl.split(":")[1];
    return (react_1.default.createElement(DraggableInsightList_1.DraggableInsightListItemBody, { className: "move-insight-placeholder", type: visualizationType, title: sdk_model_1.insightTitle(insight), updated: sdk_model_1.insightUpdated(insight), isLocked: sdk_model_1.insightIsLocked(insight) }));
}
exports.InsightDraggingComponent = InsightDraggingComponent;
//# sourceMappingURL=InsightDraggingComponent.js.map